<p-toast [style]="{'marginTop': '80px'}"></p-toast>

<!-- ═══════════════════════════════════════════════════════════════
     PAGE HEADER
════════════════════════════════════════════════════════════════ -->
<div class="gr-page-header">
  <div class="gr-page-title">
    <i class="pi pi-inbox gr-title-icon"></i>
    <div>
      <h4 class="gr-title-text">Guest Requests</h4>
      <span class="gr-title-sub">All requests submitted via the Guest Portal (taskSource = 7)</span>
    </div>
  </div>
  <div class="gr-header-actions">
    <button pButton pRipple class="p-button-outlined p-button-sm" icon="pi pi-refresh"
      label="Refresh" (click)="applyFilters()"></button>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════
     FILTER BAR
════════════════════════════════════════════════════════════════ -->
<div class="gr-filter-bar">

  <div class="gr-filter-group">
    <label class="gr-filter-label">Request Type</label>
    <p-multiSelect
      [options]="requestTypeOptions"
      [(ngModel)]="filterTypes"
      optionLabel="label" optionValue="value"
      placeholder="All types"
      [style]="{'min-width':'200px'}"
      dropdownIcon="fa fa-caret-down"
      appendTo="body"
      (onChange)="applyFilters()">
    </p-multiSelect>
  </div>

  <div class="gr-filter-group">
    <label class="gr-filter-label">Status</label>
    <p-multiSelect
      [options]="statusOptions"
      [(ngModel)]="filterStatuses"
      optionLabel="label" optionValue="value"
      placeholder="All statuses"
      [style]="{'min-width':'180px'}"
      dropdownIcon="fa fa-caret-down"
      appendTo="body"
      (onChange)="applyFilters()">
    </p-multiSelect>
  </div>

  <div class="gr-filter-group">
    <label class="gr-filter-label">Submitted From</label>
    <p-calendar
      [(ngModel)]="filterDateFrom"
      placeholder="From date"
      [showClear]="true"
      appendTo="body"
      (onSelect)="onDateFilter()"
      (onClearClick)="onDateFilter()">
    </p-calendar>
  </div>

  <div class="gr-filter-group">
    <label class="gr-filter-label">Submitted To</label>
    <p-calendar
      [(ngModel)]="filterDateTo"
      placeholder="To date"
      [showClear]="true"
      appendTo="body"
      (onSelect)="onDateFilter()"
      (onClearClick)="onDateFilter()">
    </p-calendar>
  </div>

  <div class="gr-filter-group gr-filter-actions">
    <button pButton pRipple class="p-button-text p-button-sm"
      label="Clear Filters" icon="pi pi-times" (click)="clearFilters()"></button>
  </div>

</div>

<!-- ═══════════════════════════════════════════════════════════════
     SUMMARY CHIPS
════════════════════════════════════════════════════════════════ -->
<div class="gr-summary-row">

  <!-- By request type -->
  @for (chip of summaryByType; track chip.label) {
    <div class="gr-chip" [style.border-left-color]="chip.color">
      <i [class]="chip.icon" [style.color]="chip.color"></i>
      <span class="gr-chip-label">{{ chip.label }}</span>
      <span class="gr-chip-count" [style.background]="chip.color">{{ chip.count }}</span>
    </div>
  }

  <!-- divider -->
  <div class="gr-chip-divider"></div>

  <!-- By status -->
  @for (s of summaryByStatus; track s.label) {
    <div class="gr-chip" [style.border-left-color]="s.color">
      <span class="gr-chip-label">{{ s.label }}</span>
      <span class="gr-chip-count" [style.background]="s.color">{{ s.count }}</span>
    </div>
  }

</div>

<!-- ═══════════════════════════════════════════════════════════════
     DATA TABLE
════════════════════════════════════════════════════════════════ -->
<p-table
  #pt
  [value]="requests"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="taskId"
  [loading]="loading"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25, 50, 100]"
  [totalRecords]="recordTotal"
  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped p-datatable-sm"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} requests · Page {currentPage} of {totalPages}"
  [resizableColumns]="true"
  [scrollable]="true"
  scrollHeight="calc(100vh - 370px)"
  (onRowSelect)="openRequest($event.data)"
  selectionMode="single">

  <!-- ── header ─────────────────────────────────────────────────── -->
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col.field) {
        <th [pSortableColumn]="col.field" [style.width]="col.width" [style.min-width]="col.width">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th style="width:90px; min-width:90px;">Actions</th>
    </tr>

    <!-- filter row -->
    <tr>
      <th>
        <input pInputText type="text" placeholder="ID"
          (input)="pt.filter($any($event.target).value, 'taskId', 'contains')"
          style="width:100%">
      </th>
      <th>
        <input pInputText type="text" placeholder="Reservation #"
          (input)="pt.filter($any($event.target).value, 'taskSourceId', 'contains')"
          style="width:100%">
      </th>
      <th>
        <!-- type filter already in bar above; blank cell -->
      </th>
      <th>
        <!-- status filter already in bar above; blank cell -->
      </th>
      <th>
        <input pInputText type="text" placeholder="Summary"
          (input)="pt.filter($any($event.target).value, 'name', 'contains')"
          style="width:100%">
      </th>
      <th>
        <input pInputText type="text" placeholder="Details"
          (input)="pt.filter($any($event.target).value, 'description', 'contains')"
          style="width:100%">
      </th>
      <th>
        <input pInputText type="text" placeholder="Assigned To"
          (input)="pt.filter($any($event.target).value, 'assignedToUserVO.lastName', 'contains')"
          style="width:100%">
      </th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>

  <!-- ── body ───────────────────────────────────────────────────── -->
  <ng-template pTemplate="body" let-req>
    <tr [pSelectableRow]="req" class="gr-row">

      <!-- ID -->
      <td>
        <span class="gr-id-badge">{{ req.taskId }}</span>
      </td>

      <!-- Reservation -->
      <td>
        @if (req.taskSourceId) {
          <span class="gr-link">{{ req.taskSourceId }}</span>
        } @else {
          <span class="gr-muted">—</span>
        }
      </td>

      <!-- Request Type -->
      <td>
        <span class="gr-type-badge"
          [style.background]="getRequestTypeColor(req.taskType) + '18'"
          [style.color]="getRequestTypeColor(req.taskType)"
          [style.border-color]="getRequestTypeColor(req.taskType) + '55'">
          <i [class]="getRequestTypeIcon(req.taskType)" style="margin-right:4px; font-size:11px;"></i>
          {{ getRequestTypeLabel(req.taskType) }}
        </span>
      </td>

      <!-- Status -->
      <td (click)="$event.stopPropagation()">
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="req.status"
          optionLabel="label" optionValue="value"
          appendTo="body"
          dropdownIcon="fa fa-caret-down"
          [style]="{'min-width':'130px'}"
          styleClass="gr-status-dropdown"
          (onChange)="updateStatus(req, req.status, $event.originalEvent)">
          <ng-template pTemplate="selectedItem">
            <span class="gr-status-pill"
              [style.background]="statusBgColor(req.status)"
              [style.color]="statusColor(req.status)">
              {{ getStatusLabel(req.status) }}
            </span>
          </ng-template>
        </p-dropdown>
      </td>

      <!-- Summary / name -->
      <td>
        <span [pTooltip]="req.name" tooltipPosition="top" [escape]="false">
          {{ truncate(req.name, 40) }}
        </span>
      </td>

      <!-- Description / details -->
      <td>
        <span class="gr-description" [pTooltip]="req.description" tooltipPosition="top" [escape]="false">
          {{ truncate(req.description, 55) }}
        </span>
      </td>

      <!-- Assigned To -->
      <td>
        @if (req.assignedToUserVO) {
          <span>{{ req.assignedToUserVO.firstName }} {{ req.assignedToUserVO.lastName }}</span>
        } @else {
          <span class="gr-unassigned">Unassigned</span>
        }
      </td>

      <!-- Date Submitted -->
      <td>
        <span class="gr-date">{{ req.dateCreated | date:'MM/dd/yy h:mm a' }}</span>
      </td>

      <!-- Actions -->
      <td (click)="$event.stopPropagation()">
        <button pButton pRipple
          icon="pi pi-pencil"
          class="p-button-rounded p-button-text p-button-sm"
          pTooltip="Open request"
          tooltipPosition="top"
          (click)="openRequest(req)">
        </button>
      </td>

    </tr>
  </ng-template>

  <!-- ── empty ──────────────────────────────────────────────────── -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length + 1" class="gr-empty">
        <div class="gr-empty-inner">
          <i class="pi pi-inbox" style="font-size:2.5rem; color:#94a3b8;"></i>
          <p>No guest requests found for the selected filters.</p>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>
